import { render, staticRenderFns } from "./LpuDoctorsSchedule.vue?vue&type=template&id=eda789d2&scoped=true&"
import script from "./LpuDoctorsSchedule.vue?vue&type=script&lang=ts&setup=true&"
export * from "./LpuDoctorsSchedule.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./LpuDoctorsSchedule.vue?vue&type=style&index=0&id=eda789d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eda789d2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('eda789d2')) {
      api.createRecord('eda789d2', component.options)
    } else {
      api.reload('eda789d2', component.options)
    }
    module.hot.accept("./LpuDoctorsSchedule.vue?vue&type=template&id=eda789d2&scoped=true&", function () {
      api.rerender('eda789d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuDoctorsSchedule/LpuDoctorsSchedule.vue"
export default component.exports